import type { ReactNode } from "react";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { cn } from "@/lib/utils";

export type NoticeTone = "info" | "warn" | "error" | "success";

const TONE: Record<NoticeTone, string> = {
  info: "border-slate-200 bg-slate-50 text-slate-700",
  warn: "border-amber-200 bg-amber-50 text-amber-800",
  error: "border-red-200 bg-red-50 text-red-800",
  success: "border-emerald-200 bg-emerald-50 text-emerald-800",
};

export function Notice({
  tone = "info",
  className,
  children,
}: {
  tone?: NoticeTone;
  className?: string;
  children: ReactNode;
}) {
  return (
    <Alert className={cn(TONE[tone], className)}>
      <AlertDescription>{children}</AlertDescription>
    </Alert>
  );
}
